module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00054-fs8.c93f306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00054-fs8.png
// module id = 207
// module chunks = 0